import {graphql, useLazyLoadQuery} from 'react-relay/hooks';
import useServiceLabels from './use-service-labels';

const useStemBalance = () => {
    const {getBalanceByLabel} = useLazyLoadQuery(
        graphql`
            query useStemBalanceGetBalanceByLabelQuery {
                getBalanceByLabel {
                    balance
                }
            }
        `
    );
    const {labels} = useServiceLabels();
    const offset = 100 * 1000000;
    const balance =  getBalanceByLabel.balance / offset || 0;
    return {
        balance,
        hasBalance: !!balance,
        serviceAllowPartialStemPayment: labels.allowPartialStemPayment
    }
};

export default useStemBalance;

